// 公共方法
import CryptoJS from 'crypto-js';
import http from '@/assets/js/http.js'
import store from '../../store'
//地图地址
const mapurl = "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}";
const dictArr = "建筑布局,屋瓦,屋顶,雀替纹样,柱子形式,柱子材料,柱础,柱面装饰,屋脊装饰,建筑支撑结构,窗户样式,建筑结构类型,迁徙原因类型,保存状况,损坏原因类型,铺地,屋脊,墙体材料,妈祖庙父庙,文章分类";

export default {
    mapurl: mapurl,
    baseImg() {
        return store.getters.baseImg;
        // if (sessionStorage.getItem("baseImg")) {
        //     return sessionStorage.getItem("baseImg");
        // } else {
        //     let parData = {
        //         parameterList: "baseImg",
        //     }
        //     http.From("/parameter/getParameterInfo", parData).then((res) => {
        //         if (res.code == "0") {
        //             sessionStorage.setItem("baseImg", res.data.baseImg);
        //             return res.data.baseImg;
        //         } else {}
        //     });
        // }
    },

    imgUrl() {
        return store.getters.imgUrl;
    },
    // 媒体库图片显示地址
    MediaUrl() {
        return store.getters.MediaUrl;
    },

    uploadUrl() {
        return store.getters.uploadUrl;
    },


    //随机生成指定数量的16进制key
    generatekey(num) {
        let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let key = "";
        for (var i = 0; i < num; i++) {
            let randomPoz = Math.floor(Math.random() * library.length);
            key += library.substring(randomPoz, randomPoz + 1);
        }
        return key;
    },

    //加密
    encrypt(word, keyStr) {
        keyStr = keyStr ? keyStr : 'SRSC2022INKEDAYA'; //加密规则
        let key = CryptoJS.enc.Utf8.parse(keyStr);
        let srcs = CryptoJS.enc.Utf8.parse(word);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    //解密
    decrypt(word, keyStr) {
        keyStr = keyStr ? keyStr : 'SRSC2022INKEDAYA';
        let key = CryptoJS.enc.Utf8.parse(keyStr);
        let decrypt = CryptoJS.AES.decrypt(word, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },

    dateFormat(fmt, date) {
        let ret;
        const opt = {
            "Y+": date.getFullYear().toString(), // 年
            "m+": (date.getMonth() + 1).toString(), // 月
            "d+": date.getDate().toString(), // 日
            "H+": date.getHours().toString(), // 时
            "M+": date.getMinutes().toString(), // 分
            "S+": date.getSeconds().toString() // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            };
        };
        return fmt;
    },

    test() {
        console.log("test")
    },
    //将数据转换为geoJSON格式
    toGeojson(data) {
        let geodata = {};
        geodata.type = "FeatureCollection";
        let features = [];
        geodata.features = features;
        for (let i = 0; i < data.length; i++) {
            // 坐标不为0 才写入geojson
            if (data[i].longitude && data[i].latitude) {
                let info = {};
                info.type = "Feature";
                info.geometry = {};
                info.geometry.type = "Point";
                info.geometry.coordinates = [data[i].longitude, data[i].latitude];
                info.properties = data[i];
                geodata.features.push(info);
            } else {
                // console.log(data[i]);
            }
        }
        return geodata;
    },
    // 贝叶斯曲线
    calcCoorArr(point_start, point_end, num) {
        // 入参两个坐标,num是返回坐标点个数
        var p_start = {
            x: parseFloat(point_start[0]),
            y: parseFloat(point_start[1]),
        };
        var p_end = {
            x: parseFloat(point_end[0]),
            y: parseFloat(point_end[1]),
        };

        if (p_start.y > p_end.y) {
            let item = p_start;
            p_start = p_end;
            p_end = item;
        }

        //求出相对的第三个点，用于固定曲线的弯曲度，下面公式是已知三角形两点坐标和两个坐标点的夹角求第三点坐标，两个夹角我们是自定义任意值，不过不要加起来超过180度
        // 已知两点p1(x1,y1)、p2(x2,y2)和两点所对应的角度A和B,x3、y3是对应第三点的坐标，cot25°=2.14
        //x3 = (x1*cotB+x2*cotA+y2-y1)/(cotA+cotB)
        //y3 = (y1*cotB+y2*cotA+x1-x2)/(cotA+cotB)
        let x3 =
            (p_start.x * 7.14 + p_end.x * 7.14 - p_start.y + p_end.y) / (2 * 7.14);
        let y3 =
            (p_start.y * 7.14 + p_end.y * 7.14 - p_end.x + p_start.x) / (2 * 7.14);
        var p_crt1 = {
            x: x3,
            y: y3
        };
        var p_crt2 = {
            x: x3,
            y: y3
        };
        //计算贝叶斯曲
        /**
         * 计算公式：
         *                  | 1  0  0   0|  |P0|
         * [1 t t*t  t*t*t] |-3  3  0   0|  |P1|
         *                  |3  -6  3   0|  |P2|
         *                  |-1  3  -3  1|  |p3|
         *
         * **/
        let paths = [];
        for (let i = 0; i < num + 1; i++) {
            let t = i / num;
            var _matrix1 = [1, t, t * t, t * t * t];
            var _matrix2 = [
                [1, 0, 0, 0],
                [-3, 3, 0, 0],
                [3, -6, 3, 0],
                [-1, 3, -3, 1],
            ];
            var _matrix3 = [
                [p_start.x, p_start.y],
                [p_crt1.x, p_crt1.y],
                [p_crt2.x, p_crt2.y],
                [p_end.x, p_end.y],
            ];
            var _matrix_tmp = [
                _matrix1[0] * _matrix2[0][0] +
                _matrix1[1] * _matrix2[1][0] +
                _matrix1[2] * _matrix2[2][0] +
                _matrix1[3] * _matrix2[3][0],
                _matrix1[0] * _matrix2[0][1] +
                _matrix1[1] * _matrix2[1][1] +
                _matrix1[2] * _matrix2[2][1] +
                _matrix1[3] * _matrix2[3][1],
                _matrix1[0] * _matrix2[0][2] +
                _matrix1[1] * _matrix2[1][2] +
                _matrix1[2] * _matrix2[2][2] +
                _matrix1[3] * _matrix2[3][2],
                _matrix1[0] * _matrix2[0][3] +
                _matrix1[1] * _matrix2[1][3] +
                _matrix1[2] * _matrix2[2][3] +
                _matrix1[3] * _matrix2[3][3],
            ];
            var _matrix_final = [
                _matrix_tmp[0] * _matrix3[0][0] +
                _matrix_tmp[1] * _matrix3[1][0] +
                _matrix_tmp[2] * _matrix3[2][0] +
                _matrix_tmp[3] * _matrix3[3][0],
                _matrix_tmp[0] * _matrix3[0][1] +
                _matrix_tmp[1] * _matrix3[1][1] +
                _matrix_tmp[2] * _matrix3[2][1] +
                _matrix_tmp[3] * _matrix3[3][1],
            ];

            //下面注释掉的原因是入参是经纬度，但leaflet渲染需要的是纬度在前经度在后的数组
            var _res_point = [_matrix_final[0], _matrix_final[1]];
            // var _res_point=[_matrix_final[1],_matrix_final[0]];
            paths.push(_res_point);
        }
        return paths;
    },

    //按朝代分类
    dynastyCale(date) {
        let dynasty = {
            song: 0,
            yuan: 0,
            ming: 0,
            qing: 0,
            minguo: 0,
            xiandai: 0,
            unknow: 0,
        }
        for (let i = 0; i < date.length; i++) {
            let year = parseInt(date[i].years);
            if (year <= 1279) {
                dynasty.song++;
            } else if (year > 1279 && year <= 1368) {
                dynasty.yuan++;
            } else if (year > 1368 && year <= 1644) {
                dynasty.ming++;
            } else if (year > 1644 && year <= 1912) {
                dynasty.qing++;
            } else if (year > 1912 && year <= 1368) {
                dynasty.minguo++;
            } else if (year > 1368 && year < 9999) {
                dynasty.xiandai++;
            } else {
                dynasty.unknow++;
            }
        }
        return dynasty;
    },

    //七大洲随时间增长妈祖庙修建数量
    areaTimeCale(date) {
        let titleArr = ["数量", "Country", "Year"]
        let areaArr = ["亚洲", "北美洲", "南美洲", "大洋洲", "欧洲", "非洲", "南极洲"]
        let d = new Date();
        let maxYear = d.getFullYear();
        let sunArr = [titleArr];

        for (let year = 987; year < maxYear; year += 10) {
            let nextYeay = year + 10;
            if (year + 10 >= maxYear) {
                nextYeay = maxYear;
            }
            for (let i = 0; i < areaArr.length; i++) {
                let sun = date.filter((v) => {
                    return parseInt(v.years) < nextYeay && v.continent == areaArr[i]
                })
                let item = [sun.length, areaArr[i], nextYeay];
                sunArr.push(item);
            }
        }
        return sunArr;
    },
    // this.common.dictionary();
    // this.common.dictionary("建筑布局");
    // this.common.dictionary("建筑布局", "1");

    dictionary(label, value) {
        let dict = store.state.dict.dictList;
        if (!dict) {
            JSON.parse(sessionStorage.getItem("dict"));
        };
        if (dict[label]) {
            let itemList = dict[label];
            let filterItem = itemList.filter((item) => {
                if (item.value == value) {
                    return item;
                }
            })
            if (filterItem.length > 0) {
                return filterItem[0].label;
            }
            return "暂无";
        } else {
            return "暂无";
        }
        // if (!sessionStorage.getItem("dict")) {
        //     let parData = {
        //         dictList: dictArr,
        //     };
        //     http.From("/dict/getDictList", parData).then((res) => {
        //         if (res.code == "0") {
        //             //存储字典信息
        //             sessionStorage.setItem("dict", JSON.stringify(res.data));
        //             if (res.data[label]) {
        //                 let itemList = res.data[label];
        //                 let filterItem = itemList.filter((item) => {
        //                     if (item.value == value) {
        //                         return item;
        //                     }
        //                 })
        //                 if (filterItem.length > 0) {
        //                     return filterItem[0].label;
        //                 }
        //                 return "暂无"

        //             } else {
        //                 return "暂无"
        //             }

        //         } else {}
        //     });
        // }
        // if (!value) {
        //     return "暂无"
        // } else {
        //     // let dict = JSON.parse(sessionStorage.getItem("dict"));
        //     let dict = store.state.dict.dictList
        //     if (dict[label]) {
        //         let itemList = dict[label];
        //         let filterItem = itemList.filter((item) => {
        //             if (item.value == value) {
        //                 return item;
        //             }
        //         })
        //         if (filterItem.length > 0) {
        //             return filterItem[0].label;
        //         }
        //         return "暂无"
        //     } else {
        //         return "暂无"
        //     }

        // }

    },

    // dictionaryList(label) {
    //     if (!sessionStorage.getItem("dict")) {
    //         let parData = {
    //             dictList: dictArr,
    //         };
    //         http.From("/dict/getDictList", parData).then((res) => {
    //             if (res.code == "0") {
    //                 //存储字典信息
    //                 sessionStorage.setItem("dict", JSON.stringify(res.data));
    //                 if (res.data[label]) {
    //                     return res.data[label];
    //                 }
    //             } else {}
    //         });
    //     }
    //     //获取字典选项列表 
    //     if (label) {
    //         let dict = JSON.parse(sessionStorage.getItem("dict"));
    //         if (dict[label]) {
    //             return dict[label];
    //         }
    //     }
    // },

    //按朝代分类
    getDynasty(date) {
        if (!date) {
            return "暂不详";
        } else {
            let year = parseInt(date);
            if (year <= 1279) {
                return "宋代";
            } else if (year > 1279 && year <= 1368) {
                return "元代";
            } else if (year > 1368 && year <= 1644) {
                return "明代";
            } else if (year > 1644 && year <= 1912) {
                return "清代";
            } else if (year > 1912 && year <= 1368) {
                return "民国";
            } else if (year > 1368 && year < 9999) {
                return "现代";
            } else {
                return "暂不详";
            }
        }

    },

}